import React from 'react';
import Box from '@mui/material/Box';

const PaddedCentralBox = ({ children }) => (
    <Box sx={{ paddingTop: 10, display: 'flex', justifyContent: 'center' }}>
        {children}
    </Box>
);

export default PaddedCentralBox;